module.exports = __webpack_public_path__ + "img/AX-Spinner-2.47bf1202.gif";